import { Text, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { Spinner } from '../../shared/Spinner';
import { useLoginDialogManager } from './useLoginDialogManager';
import { LOGIN_DEFAULT_ERROR_MESSAGE } from '../../../constants/data';
import { Modal } from '../../shared/modal/Modal';
import { FormularioOtp } from '../../canje/FormularioOtp';
import { NOMBRE_HOMEBANKING } from '../../../constants/data';
import { LoginDialogCallback } from './LoginDialogState';
import { LoginTitle } from './LoginTitle';
import { InputEmail } from '../../shared/form/InputEmail';
import { EMAIL_MAX_LENGTH } from '../../../constants/form';
import { AdditionalLinksContainer } from './AdditionalLinksContainer';
import { AceptacionTyC } from './AceptacionTyC';

type Props = {
  show: boolean;
  onCancel: () => void;
  /**Callback que es llamado luego de completarse la autenticaci�n */
  afterLogin?: LoginDialogCallback;
};

export const LoginDialog: FC<Props> = ({ show, onCancel, afterLogin }) => {
  const [
    isLoading,
    isRequestError,
    requestErrorMessage,
    emailBlocked,
    showEmail,
    showTokenInput,
    showConfirmButton,
    showCancelButton,
    reset,
    confirm,
    estadoTycs,
    setEstadoTycs,
    alreadyAcceptTycs,
    otp,
    setOtp,
    formRegister,
    formErrors,
  ] = useLoginDialogManager(onCancel, afterLogin);
  const errorMessage =
    requestErrorMessage?.trim && requestErrorMessage.trim().length > 0 ? requestErrorMessage : LOGIN_DEFAULT_ERROR_MESSAGE;
  const showLinks = showEmail && !emailBlocked;

  /**Caso de error que no se puede resolver reingresando datos.*/
  const isIrrecoverableError = !(showEmail || showTokenInput) && !isLoading;
  /**aceptacion de nuevos terminos y condiciones para ingresar otp**/
  const showTycs = !alreadyAcceptTycs && showTokenInput && !isLoading;
  const showOTP = (showTokenInput && alreadyAcceptTycs) || (showTokenInput && !alreadyAcceptTycs && estadoTycs);

  const getConfirmButtonLabel = () => {
    if (isIrrecoverableError) return 'Finalizar';

    return undefined;
  };
  const getConfirmButtonAction = () => {
    if (isIrrecoverableError) return reset;

    return confirm;
  };

  return (
    <Modal
      show={show}
      title={<LoginTitle />}
      onConfirm={getConfirmButtonAction()}
      confirmLabel={getConfirmButtonLabel()}
      showConfirmButton={showConfirmButton || isIrrecoverableError}
      onCancel={reset}
      showCancelButton={showCancelButton}
      showErrorMessage={isRequestError}
      errorMessage={errorMessage}
      childrenAfterButtons={showLinks ? <AdditionalLinksContainer /> : undefined}
    >
      <>
        {isLoading && <Spinner width={313} />}
        <VStack>
          <VStack display={showEmail ? 'flex' : 'none'} aria-hidden={emailBlocked}>
            <Text color={emailBlocked ? 'secondary.1' : 'primary.0'} tabIndex={emailBlocked ? -1 : 0} py={'16px'}>
              Ingresá el e-mail validado en <b>{NOMBRE_HOMEBANKING}</b>
            </Text>
            <InputEmail
              placeholder="Email (ej.: ejemplo@correo.org.ar)"
              name="email"
              readOnly={emailBlocked}
              required={true}
              maxLength={EMAIL_MAX_LENGTH}
              formRegister={formRegister}
              errorCollection={formErrors}
            />
          </VStack>
          {showTycs && <AceptacionTyC aceptaTyc={setEstadoTycs} estadoTycs={estadoTycs} />}
          {showOTP && (
            <FormularioOtp
              display={showTokenInput ? 'flex' : 'none'}
              otp={otp}
              setOtp={setOtp}
              ariaHidden={!showTokenInput}
              onComplete={confirm}
            />
          )}
        </VStack>
      </>
    </Modal>
  );
};
